/**
 * Design-QA route for the Profile screen (mirrors AwardsReview).
 * Mounts <ProfileView> with fabricated mid-journey data. Variants:
 *
 *   /profile-review            — Pro user (gold ring + PRO chip, active row)
 *   /profile-review?state=free — free user (promo subscription card)
 *   /profile-review?state=past_due — past-due alert + danger row
 */
import { useSearchParams } from 'react-router';
import { Icon, NavRow } from '@fluent/ui';
import { ProfileView } from './screens/Profile.js';
import { CrownGlyph, CardGlyph } from './profile/icons.js';
import type { DerivedStatus } from './subscription/access.js';

const noop = () => undefined;

export function ProfileReview() {
  const [params] = useSearchParams();
  const variant = params.get('state') ?? 'pro';
  const subStatus: DerivedStatus =
    variant === 'free' ? 'none' : variant === 'past_due' ? 'past_due' : 'active';

  return (
    <ProfileView
      data={{
        displayName: 'ნინო ბერიძე',
        email: 'nino.beridze@example.com',
        avatarUrl: undefined,
        memberSinceIso: '2026-04-12T09:00:00Z',
        hasPro: subStatus === 'active',
        subStatus,
        totalXp: 1250,
        streakCurrent: 8,
        streakLongest: 21,
        words: 116,
        lessons: 34,
        coins: 87,
        monthAwarded: 63,
        monthCap: 400,
        showInstall: true,
        showAdmin: false,
      }}
      onEdit={noop}
      onOpenSubscription={noop}
      onOpenAwards={noop}
      onSettings={noop}
      onInstall={noop}
      onAdmin={noop}
      onLogout={noop}
      subscriptionSlot={
        subStatus === 'none' ? undefined : (
          <NavRow
            icon={
              <span
                className="fluent-subrow__tile"
                data-state={subStatus}
                aria-hidden="true"
              >
                <Icon size={24}>{subStatus === 'past_due' ? <CardGlyph /> : <CrownGlyph />}</Icon>
              </span>
            }
            title={subStatus === 'past_due' ? 'თანხა ვერ ჩამოიჭრა' : 'Pro აქტიურია'}
            sub={subStatus === 'past_due' ? 'შეცვალე საბანკო ბარათი' : 'შემდეგი ჩამოჭრა — 16 აგვისტო'}
            onPress={noop}
          />
        )
      }
    />
  );
}
